import { Card, CardBody, CardHeader } from 'reactstrap';

const SectionCard = ({
    number,
    title,
    description,
    children,
}) => (
    <Card className="mailer-settings__section mb-4">
        <CardHeader className="bg-white py-3">
            <h5 className="font-size-16 mb-0">
                {number ? `${number}. ` : ''}
                {title}
            </h5>
            {description && (
                <p className="text-muted font-size-12 mb-0 mt-1">
                    {description}
                </p>
            )}
        </CardHeader>
        <CardBody>
            {children}
        </CardBody>
    </Card>
);

export default SectionCard;
